import { useDroppable } from '@dnd-kit/core';
import { Group, Stack } from '@mantine/core';
import {
	HORIZONTAL_INDICATOR_ABOVE_ID_PREFIX,
	HORIZONTAL_INDICATOR_BELOW_ID_PREFIX,
} from './constants';
import { DnDHorizontalIndicator } from './DnDHorizontalIndicator';
import type { DnDItem } from './types';

interface DnDProps<T> {
	id: string;
	items: DnDItem<T>[];
	isFirstRow: boolean;
	isLastRow: boolean;
	readOnly?: boolean;
	children: React.ReactNode;
}

export function DnDRow<T>({
	id,
	items,
	isFirstRow,
	isLastRow,
	readOnly = false,
	children,
}: DnDProps<T>) {
	const { setNodeRef } = useDroppable({
		id,
		data: {
			type: 'row',
			children: items,
		},
	});

	return (
		<Stack ref={setNodeRef} w="100%" spacing={0}>
			<DnDHorizontalIndicator
				id={`${HORIZONTAL_INDICATOR_ABOVE_ID_PREFIX}-${id}`}
				isFirstRow={isFirstRow}
				isLastRow={isLastRow}
				readOnly={readOnly}
			/>
			<Group w="100%" spacing={0} noWrap>
				{children}
			</Group>
			{isLastRow && (
				<DnDHorizontalIndicator
					id={`${HORIZONTAL_INDICATOR_BELOW_ID_PREFIX}-${id}`}
					isFirstRow={isFirstRow}
					isLastRow={isLastRow}
					readOnly={readOnly}
				/>
			)}
		</Stack>
	);
}
